// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import DashboardNavigation from './DashboardNavigation';
import { PrimaryRoute } from './fragments/PrimaryNavigationList';
import { SecondaryRoute } from './fragments/SecondaryNavigation';

export default DashboardNavigation;
export type { PrimaryRoute, SecondaryRoute };
